import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {Client, IMessage, StompSubscription} from "@stomp/stompjs";
import {environment} from "../../../../environments/environment";
import {chatList} from "../../../shared/model/page.model";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../../../auth/service/auth.service";

@Injectable({

  providedIn: 'root'

})

export class ChatService {
  private stompClient!: Client;
  private subscriptions: StompSubscription[] = [];
  private messageSubject: Subject<any> = new Subject<any>();
  public messageReceived$ = this.messageSubject.asObservable();

  private publicMessageSubject: Subject<any> = new Subject<any>();
  public publicMessageReceived$ = this.publicMessageSubject.asObservable();

  private messageDeletedSubject = new Subject<string>();
  public messageDeleted$ = this.messageDeletedSubject.asObservable();

  private messageApproveSubject = new Subject<chatList>();
  public messageApprove$ = this.messageApproveSubject.asObservable();

  private initialized = false;

  private chatStatus = new BehaviorSubject<boolean>(false);
  public chatStatus$ = this.chatStatus.asObservable();


  constructor(private http: HttpClient, private authService: AuthService) {
  }

  async initialize(eventId: any) {
    if (this.initialized) return;
    this.initialized = true;
    this.loadChatHistory(eventId);
    this.loadChatHistoryPublic(eventId);


    try {
      const token = await this.authService.getAccessToken();
      if (!token) {
        throw new Error('Token is empty or invalid');
      }
      this.stompClient = new Client({
        brokerURL: `${environment.webSocketUrl}?token=${token}`,
        reconnectDelay: 5000,
      });


      this.stompClient.onConnect = () => {
        this.chatStatus.next(true);
        // Admin topic
        this.subscriptions.push(
          this.stompClient.subscribe(`/topic/admin/${eventId}`, (message: IMessage) => {
            const body = JSON.parse(message.body);
            this.messageSubject.next(body);
          })
        );
        this.subscriptions.push(
          this.stompClient.subscribe(`/topic/public/admin/${eventId}`, (message: IMessage) => {
            const body = JSON.parse(message.body);
            this.publicMessageSubject.next(body);
          })
        );
        this.subscriptions.push(
          this.stompClient.subscribe(`/topic/delete/${eventId}`, (message: IMessage) => {
            const body = JSON.parse(message.body);
            this.messageDeletedSubject.next(body);
          })
        );
        this.subscriptions.push(
          this.stompClient.subscribe(`/topic/update-status/${eventId}`, (message: IMessage) => {
            const body = JSON.parse(message.body);
            this.messageApproveSubject.next(body);
          })
        );

      };

      this.stompClient.onStompError = (frame) => {
      };

      this.stompClient.activate();
    } catch (err) {
    }
  }


  sendMessage(chatMessage: any) {
    if (this.stompClient.connected) {
      this.stompClient.publish({
        destination: '/app/chat.send',
        body: JSON.stringify(chatMessage),
      });
    }
  }

  sendPrivateMessageReply(chatMessage: any) {
    if (this.stompClient.connected) {
      this.stompClient.publish({
        destination: '/app/chat.privateReply',
        body: JSON.stringify(chatMessage),
      });
    }
  }

  approveMessage(message: any) {
    if (this.stompClient.connected) {
      this.stompClient.publish({
        destination: '/app/chat.approve',
        body: JSON.stringify(message),
      });
    }
  }

  deleteMessage(chatMessage: any) {
    if (this.stompClient.connected) {
      this.stompClient.publish({
        destination: '/app/chat.delete',
        body: JSON.stringify(chatMessage),
      });
    }
  }

  closeConnection() {
    if (this.stompClient && this.stompClient.active) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
      this.subscriptions = [];
      this.stompClient.deactivate(); // clean close
    }
    this.initialized = false;
  }

  baseURL = environment.baseUrl

  private loadChatHistory(eventId: number) {
    this.http.get<any[]>(`${this.baseURL}chat-history/private/admin/${eventId}`).subscribe({
      next: (messages) => {
        messages.forEach((msg) => this.messageSubject.next(msg));
      }
    });
  }

  private loadChatHistoryPublic(eventId: number) {
    this.http.get<any[]>(`${this.baseURL}chat-history/public/admin/${eventId}`).subscribe({
      next: (messages) => {
        messages.forEach((msg) => this.publicMessageSubject.next(msg));
      }
    });
  }
}


